// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44375e30","455":"820fb06a","977":"03e8471c"}[chunkId] + ".chunk.js";
};